import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import SwiperCore, { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import "./LatestInfo.css";
import ImageFrame from "./ImageFrame";
import chevronLeft from "./assets/svg/chevron-left-large.svg";
import chevronRight from "./assets/svg/chevron-right-large.svg";
import arrowIcon from "./assets/svg/arrow.svg";
import defaultImage from "./assets/image.png";

SwiperCore.use([Pagination]);

const BASE = "https://beszeljegyesulet.hu/wp/wp-json/wp/v2";
const EXCLUDE_CATEGORY_NAME = "Az én dadogásom";

const decodeEntities = (str) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = str;
  return txt.value;
};

const getExcerpt = (post) => {
  const raw = post.excerpt?.rendered ?? "";
  const stripped = raw.replace(/<[^>]+>/g, "");
  const decoded = decodeEntities(stripped);
  return decoded.substring(0, 180) + "…";
};

const LatestInfo = () => {
  const [posts, setPosts] = useState([]);
  const swiperRef = useRef(null);
  const location = useLocation();

  const headingText =
    location.pathname === "/stuttering"
      ? "További cikkek a témában"
      : "Tudástár";

  useEffect(() => {
    fetch(`${BASE}/categories?per_page=100`)
      .then((r) => r.json())
      .then((cats) => {
        const cat = cats.find(
          (c) => c.name === EXCLUDE_CATEGORY_NAME || c.slug === "az-en-dadogasom"
        );
        const excludeParam = cat ? `&categories_exclude=${cat.id}` : "";
        return fetch(`${BASE}/posts?_embed${excludeParam}`).then((r) => r.json());
      })
      .then((data) => { if (Array.isArray(data)) setPosts(data); })
      .catch((err) => console.error("API fetch error:", err));
  }, []);

  const handlePrev = () => { swiperRef.current?.slidePrev(); };
  const handleNext = () => { swiperRef.current?.slideNext(); };

  return (
    <section className="latestinfo">
      <h2 className="heading-sm">{headingText}</h2>
      <div className="latestinfo-carousel">
        <button className="custom-nav latestinfo-prev" aria-label="Előző" onClick={handlePrev}>
          <img src={chevronLeft} alt="" />
        </button>
        <button className="custom-nav latestinfo-next" aria-label="Következő" onClick={handleNext}>
          <img src={chevronRight} alt="" />
        </button>
        <Swiper
          spaceBetween={24}
          slidesPerView={3}
          slidesPerGroup={1}
          loop={true}
          loopedSlides={3}
          onSwiper={(swiper) => { swiperRef.current = swiper; }}
          pagination={{ el: ".latestinfo-pagination", clickable: true }}
          breakpoints={{
            0: { slidesPerView: 1 },
            769: { slidesPerView: 3 },
          }}
        >
          {posts.length === 0 ? (
            <SwiperSlide>
              <div className="info-card loading">Betöltés...</div>
            </SwiperSlide>
          ) : (
            posts.map((post) => {
              const featured =
                post._embedded?.["wp:featuredmedia"]?.[0]?.source_url || defaultImage;
              return (
                <SwiperSlide key={post.id}>
                  <div className="info-card">
                    <ImageFrame post={post} src={featured} alt={post.title.rendered} />
                    <div className="info-content">
                      <h3
                        className="heading-md"
                        dangerouslySetInnerHTML={{ __html: post.title.rendered }}
                      />
                      <p>{getExcerpt(post)}</p>
                      <a href={`/posts/${post.slug}`} className="info-link">
                        Tovább{" "}
                        <img src={arrowIcon} alt="nyíl ikon" className="arrow-icon" />
                      </a>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })
          )}
          <div className="swiper-pagination latestinfo-pagination"></div>
        </Swiper>
      </div>
    </section>
  );
};

export default LatestInfo;